<template>
  <div class="error404">
    <div class="error-container">
      <div class="left-content">
        <div class="error-log">
          <img src="@/assets/images/error/logo.png" alt="">
        </div>
        <div class="error-code">
          <img src="@/assets/images/error/404.png" alt="">
        </div>
        <div class="error-tips">
          <div class="error-text">Hi，真不巧，网页走丢了，点击返回上一页</div>
          <div @click="goBack" class="wl-btn-normal goback">
            返回上一页
          </div>
          <div @click="relogin" class="wl-btn-normal goback" style="margin-left: 10px;">
            重新登陆
          </div>
        </div>
      </div>
      <div class="right-img">
        <img src="@/assets/images/error/404big.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'error404',
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {
      goBack(){
        this.$router.go(-1)
      },
      relogin() {
        this.$store.dispatch('user/resetToken')
        this.$nextTick(() => {
          this.$router.push({
            path: '/login'
          })
        })
      },
    }
  }
</script>

<style lang="scss">
.error404{
  height: 100%;
  width: 100%;
  position: relative;
  background:linear-gradient(133deg,rgba(72,139,255,1) 0%,rgba(36,93,240,1) 100%);
  .error-container{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background:rgba(255,255,255,1);
    border-radius:20px;
    width:1016px;
    height:550px;
    display: flex;
    overflow: hidden;
    .left-content,.right-img{
      width: 50%;
    }
    .left-content{
      padding: 17px 0 0 110px;
      .error-log{
        img{
          width:161px;
        }
      }
      .error-code{
        padding: 56px 0 36px 0;
        img{
          width:286px;
        }
      }
      .error-tips{
        font-size: 12px;
        color: #333;
        .error-text{
          padding-bottom: 25px;
        }
        .goback{
          color: #333;
        }
      }
    }
    .right-img{
      img{
        width: 101%;
        height: 101%;
      }
    }
  }

}
</style>
